import React from 'react';

interface Props {
    g2link: string|null;
}

function G2Link({ g2link }: Props) {

    console.log(g2link);

    if (g2link) {
        return (
            <a href={g2link}>Sign into FileInvite for Lending (Recommended)</a>
        );
    }

    return (<span></span>);
}

export default G2Link;
